import axios, {AxiosError, AxiosResponse} from 'axios';
import {ExercisesObject, TaskObject} from './types';
import {ErrorObject} from 'types';

/**
 * Get all tasks.
 * @return {Promise<TaskObject[] | ErrorObject>}
 */
export async function getTasks() {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/exercises`,
  }).then((response: AxiosResponse<ExercisesObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Get the task.
 * @param {TaskObject["id"]} id
 * @return {Promise<(ExercisesObject)>}
 */
export async function getTask(id: TaskObject['id']) {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/exercises/${id}`,
  }).then((response: AxiosResponse<ExercisesObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Create task.
 * @param {Omit<ExercisesObject, "id">} task
 * @return {Promise<(ExercisesObject)>}
 */
export async function createTask(task: Omit<ExercisesObject, 'id'>) {
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_BASE_URL}/exercises`,
    data: JSON.stringify(task),
  }).then((response: AxiosResponse<ExercisesObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Delete task.
 * @param {ExercisesObject['id']} id
 * @return {Promise<(ExercisesObject)>}
 */
export async function deleteTask(id: ExercisesObject['id']) {
  return axios({
    method: 'DELETE',
    url: `${process.env.REACT_APP_API_BASE_URL}/exercises/${id}`,
  }).then((response: AxiosResponse<ExercisesObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
